import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vuqdpdbt5: FaireProductEntity = {
  token: "p_2vuqdpdbt5",
  type: "product",
  name: "First Aid Kit Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0cbbe4ebac35a5ca9659d5efe8947c3e2b4efa1009bd387b6b85e54798cd85ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d6ae865ed107fce646c0b32ba63bb4d5d9b743c65b26ed7a963cb97088e1b45.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:48.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
